import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLikeBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "like" }), /* @__PURE__ */ _jsx("path", { d: "M23.75,11.565a2.253,2.253,0,0,0-2.25-2.25H14.774a.25.25,0,0,1-.244-.306,25.026,25.026,0,0,0,.72-4.725,3.35,3.35,0,0,0-.757-2.3,2.349,2.349,0,0,0-1.748-.8,1.9,1.9,0,0,0-1.995,1.88A7.193,7.193,0,0,1,4,10.315H1a.75.75,0,0,0-.75.75v9a.75.75,0,0,0,.75.75c4.532,0,6.009.635,7.312,1.193A8.044,8.044,0,0,0,12,22.815h6.5a2.251,2.251,0,0,0,2.019-3.244,2.251,2.251,0,0,0,1-3,2.251,2.251,0,0,0,1-3A2.251,2.251,0,0,0,23.75,11.565Z" })]
});
export default SvgLikeBold;
